// utils/processFlights.js

// Normalize date format (remove 'T' if exists)
const normalizeDate = (dt) => {
  if (!dt) return "";
  return dt.replace("T", " ").trim();
};

export const processFlights = (data) => {
  if (!data) return [];

  const result = [...data];

  const supplier1 = result.filter(f => f.Supplier === 1);
  // const supplier7 = result.filter(f => f.Supplier === 8);
  const supplier7 = result.filter(f => [7, 3].includes(f.Supplier));

  let matched = false;

  supplier1.forEach(s1 => {
    const s1From = normalizeDate(s1.FromUTCTime);
    const s1To = normalizeDate(s1.ToUTCTime);

    const match = supplier7.find(s7 => {
      const s7From = normalizeDate(s7.FromUTCTime);
      const s7To = normalizeDate(s7.ToUTCTime);

      return (
        s7.FlightNumber === s1.FlightNumber &&
        s7From === s1From &&
        s7To === s1To
      );
    });

    if (match) {
      matched = true;

      if (Number(s1.PubFare) > Number(match.PubFare)) {
        const difference = Number(s1.PubFare) - Number(match.PubFare);

        const index = result.findIndex(
          r => (r.Supplier === 3 || r.Supplier === 7) && r.keyIndex === match.keyIndex
        );

        if (index !== -1) {
          result[index] = {
            ...result[index],
            isSpecial: difference
          };
        }
      }
    }
  });

  // If no match found, return original data fully
  return result;
};
